import { connect } from 'react-redux';

import { getUpdatingFunnelDashboard } from '../../../../../reducers/analyticsApp';
import { addFunnelStep, changeFunnelStepPosition } from '../../../../../actions/dashboards/funnels';
import CompoundUpdateStepContainer from '../../../../../components/compound/update/StepContainer';

const mapStateToProps = (state, { unit }) => ({
  steps: getUpdatingFunnelDashboard(state, unit.id).steps,
});

const mapDispatchToProps = (dispatch, { unit }) => ({
  onAddStep: () => dispatch(addFunnelStep(unit.id)),
  onChangeStepPosition: (oldIndex, newIndex) =>
    dispatch(changeFunnelStepPosition(oldIndex, newIndex, unit.id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CompoundUpdateStepContainer);
